import React, { useState, useEffect } from 'react';
import { Button, Container, Form, Table, Row } from 'react-bootstrap';
import { db, functions } from '../firebase-config';
import { httpsCallable } from 'firebase/functions';
import { collection, getDocs, /*doc, updateDoc*/ } from "firebase/firestore";
// import { useNavigate } from 'react-router-dom';

import { useAuth } from '../Context/AuthContext';
import StatusSpinner from '../Components/StatusSpinner';

import { toast } from 'react-toastify';

// const navigate = useNavigate();

export default function EmployeeClientSettings() {
  const { showSpinner, setShowSpinner } = useAuth();
  const [userClientStatusEmail, setUserClientStatusEmail] = useState('');
  const [listOfClientEmails, setListOfClientEmails] = useState([""]);
  const [clientInfo, setClientInfo] = useState([]);

  const [chosenClient, setChosenClient] = useState({id: ''});
  const [chosenClientLocationIDs, setChosenClientLocationIDs] = useState([]);
  const [assignedLocationIDsIndex, setAssignedLocationIDsIndex] = useState([]);
  const [assignedLocationIDs, setAssignedLocationIDs] = useState([]);
  const [fullClientInfo, setFullClientInfo] = useState([]);

  useEffect(()=>{
      setShowSpinner(true);
      getDocs(collection(db, "clients")).then((snapShot)=>{
          let emailList = [""];
          let clientTempInfo = [];
          snapShot.forEach((doc)=>{
            if(doc.data()?.deleted === undefined || !doc.data()?.deleted){
              emailList.push(doc.data().email);
              clientTempInfo.push({...doc.data(), id: doc.id});
            }
          });
          return {emailList: emailList, clientInfo: clientTempInfo};
      }).then((info)=>{
          setShowSpinner(false);
          setListOfClientEmails(info.emailList);
          setClientInfo(info.clientInfo);
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Error getting client email list: ${error.message}`);
      });
      // load all clients from database
      getDocs(collection(db, "client_information")).then((snapShot)=>{
        // go through each client and set array of all clientInfo
        let tempClientInfo = [{id: ''}];
        snapShot.forEach((doc)=>{
            tempClientInfo.push({...doc.data(), id: doc.id});
        })
        tempClientInfo.sort((a,b)=>{
            if(a.Customer < b.Customer) return -1;
            if(a.Customer > b.Customer) return 1;
            return 0;
        })
        setFullClientInfo(tempClientInfo);
        setShowSpinner(false);
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Error getting client list: ${error.message}`);
      });
  }, [setShowSpinner]);
  
  const updateAssignedLocations = (event)=>{
    const indexList = [].slice.call(event.target.selectedOptions).map(item => item.value);
    let tempAssigneLocationIDs = [];

    setAssignedLocationIDsIndex(indexList);

    indexList.forEach((index)=>{
      tempAssigneLocationIDs.push(chosenClientLocationIDs[index].id);
    });
    setAssignedLocationIDs(tempAssigneLocationIDs);
  };

  const emailClicked = (email)=>{
    setUserClientStatusEmail(email)
    if(email === ''){
      setChosenClient({id: ''});
      setChosenClientLocationIDs([]);
      setAssignedLocationIDsIndex([]);
      setAssignedLocationIDs([]);
    }else{
      let tempChosenClient = clientInfo.find((client) => client.email === email)
      if(tempChosenClient.links.client !== undefined){
        setChosenClient(tempChosenClient.links.client);
        const tempChosenLocationIDs = fullClientInfo.find((element) => element.id === tempChosenClient.links.client)?.Locations;
        if(tempChosenLocationIDs !== undefined){
          setChosenClientLocationIDs(tempChosenLocationIDs)
        }else{
          setChosenClientLocationIDs([])
        }
        if(tempChosenClient?.links?.locations !== undefined && tempChosenClient.links.locations.length > 0){
          let tempAssignedLocationIDsIndex = [];
          tempChosenLocationIDs.forEach((location, index)=>{
            if(tempChosenClient.links.locations.findIndex((element)=> element === location.id) > -1){
              tempAssignedLocationIDsIndex.push(index);
            }
          });
          setAssignedLocationIDsIndex(tempAssignedLocationIDsIndex)
          setAssignedLocationIDs(tempChosenClient.links.locations);
        }else{
          setAssignedLocationIDsIndex([]);
          setAssignedLocationIDs([]);
        }
      }else{
        setChosenClient({id: ''});
        setChosenClientLocationIDs([]);
        setAssignedLocationIDsIndex([]);
        setAssignedLocationIDs([]);
      }
    }
  };

  const handleCreateClientClick = ()=>{
    const index = clientInfo.findIndex((info) => info.email === userClientStatusEmail);
    setShowSpinner(true);
    const addClientRole = httpsCallable(functions, "addClientRole");
    addClientRole({ email: userClientStatusEmail, links: {client: chosenClient, locations: assignedLocationIDs} }).then((result)=>{
      setShowSpinner(false);
      if(result.data.status === 200){
        let tempClientInfo = [...clientInfo];
        tempClientInfo[index] = {
          ...tempClientInfo[index],
          'status': 'client',
          'links': {client: chosenClient, locations: assignedLocationIDs},
        }
        setClientInfo(tempClientInfo);
        toast.success(result.data.message);
        setUserClientStatusEmail('');
        setChosenClient({id: ''});
        setChosenClientLocationIDs([]);
        setAssignedLocationIDsIndex([]);
        setAssignedLocationIDs([]);
      }else{
        toast.error(result.data.message);
      }
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Error saving ${userClientStatusEmail} access: ${error.message}`);
    });
  };

  const handleUpdateClientClick = ()=>{
    const index = clientInfo.findIndex((info) => info.email === userClientStatusEmail);
    setShowSpinner(true);
    const updateClientLinks = httpsCallable(functions, "updateClientLinks");
    updateClientLinks({ email: userClientStatusEmail, links: {client: chosenClient, locations: assignedLocationIDs} }).then((result)=>{
      setShowSpinner(false);
      if(result.data.status === 200){
        let tempClientInfo = [...clientInfo];
        tempClientInfo[index] = {
          ...tempClientInfo[index],
          'links': {client: chosenClient, locations: assignedLocationIDs},
        }
        setClientInfo(tempClientInfo);
        toast.success(result.data.message);
        setUserClientStatusEmail('');
        setChosenClient({id: ''});
        setChosenClientLocationIDs([]);
        setAssignedLocationIDsIndex([]);
        setAssignedLocationIDs([]);
      }else{
        toast.error(result.data.message);
      }
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Error saving ${userClientStatusEmail} access: ${error.message}`);
    });
  };

  const handleRevokeClientClick = ()=>{
    const index = clientInfo.findIndex((info) => info.email === userClientStatusEmail);
    setShowSpinner(true);
    const revokeClientRole = httpsCallable(functions, "revokeClientRole");
    revokeClientRole({ email: userClientStatusEmail }).then((result)=>{
      setShowSpinner(false);
      if(result.data.status === 200){
        let tempClientInfo = [...clientInfo];
        tempClientInfo[index] = {
          ...tempClientInfo[index],
          'status': 'revoked',
          'links': {},
        }
        setClientInfo(tempClientInfo);
        toast.success(result.data.message);
        setUserClientStatusEmail('');
        setChosenClient({id: ''});
        setChosenClientLocationIDs([]);
        setAssignedLocationIDsIndex([]);
        setAssignedLocationIDs([]);
      }else{
        toast.error(result.data.message);
      }
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Error saving ${userClientStatusEmail} access: ${error.message}`);
    });
  };

  return(
    <>
      <Container fluid style={{width:"100%",paddingLeft:"70px", marginRight:"70px"}}>
          <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
              <Row className="justify-content-center">
                  CLIENT SETTINGS
              </Row>
          </Container>
      </Container>
      <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
          <div className="w-100" style={{maxWidth: "600px"}}>
              <div className="mt-5">
                  <Form.Group  style={{textAlign:"left"}} id="admin-set-email">
                      <Form.Label>Email to add/revoke client status</Form.Label>
                      <Form.Select value={userClientStatusEmail} onChange={(event)=>{
                        emailClicked(event.target.value);
                      }}>
                          {
                              listOfClientEmails.map((email, index)=>{
                                  return(<option key={index} value={email}>{email}</option>)
                              })
                          }
                      </Form.Select>
                      <Form.Label className="mt-4">Customer:</Form.Label>
                      <Form.Select value={chosenClient} onChange={(event)=>{
                          setChosenClient(event.target.value)
                          if(fullClientInfo[event.target.selectedIndex].id !== ''){
                            setChosenClientLocationIDs(fullClientInfo[event.target.selectedIndex].Locations)
                          }else{
                            setChosenClientLocationIDs([])
                          }
                      }}>
                          {
                            fullClientInfo.map((info, index)=>{
                                return(<option key={index} value={info.id}>{info.Customer}</option>)
                            })
                          }
                      </Form.Select>
                      <Form.Label className="mt-4">Locations:</Form.Label>
                      <Form.Control as="select" multiple value={assignedLocationIDsIndex} onChange={(event)=>{
                          updateAssignedLocations(event)
                      }}>
                          {
                            chosenClientLocationIDs.map((location, index)=>{
                                return(<option key={index} value={index}>{location.Address}</option>)
                            })
                          }
                      </Form.Control>
                  </Form.Group>
              </div>
              {
                  clientInfo.find(({email}) => email === userClientStatusEmail)?.status === 'revoked' ?
                      <div className="mt-3">
                        <Button 
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={handleCreateClientClick}
                        >
                          Create client
                        </Button>
                      </div>
                  :
                      clientInfo.find(({email}) => email === userClientStatusEmail)?.status === 'client' ?
                          <div className="mt-3">
                            <Button
                              className="btn-dark"
                              style={{backgroundColor:"#2596be", margin:5}}
                              onClick={handleRevokeClientClick}
                            >
                              Revoke client
                            </Button>
                            <Button
                              className="btn-dark"
                              style={{backgroundColor:"#2596be", margin:5}}
                              onClick={handleUpdateClientClick}
                            >
                              Update Customer/Locations
                            </Button>
                          </div>
                      :
                          ''
              }
          </div>
      </Container>
      <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
        <div className="w-100" style={{maxWidth: "600px"}}>
          <div className="mt-5">
            <Table>
              <thead>
                <tr>
                  <th>Client Name</th>
                  <th>Email</th>
                  <th>Customer</th>
                  <th>Client Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  clientInfo.map((client, index)=>{
                      return(
                        <tr
                          key={index}
                          style={{cursor:"pointer"}}
                          onClick={() => {
                            emailClicked(client.email);
                          }}
                        >
                          <td>{client?.client_name}</td>
                          <td>{client?.email}</td>
                          <td>{fullClientInfo.find((element) => element.id === client?.links?.client)?.Customer}</td>
                          <td style={{color:
                                  client?.status === undefined ?
                                      "red" 
                                  :
                                      client.status === "client" ?
                                          "green"
                                      :
                                          "red"
                              }}
                          >{client?.status !== undefined ? client.status : "revoked"}</td>
                        </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
        {
        showSpinner &&
          <StatusSpinner />
        }
      </Container>
    </>
  )
}